import React from 'react';
import 'twin.macro';
import { filterEmpty } from '@/utils/index';
import FooterList from './FooterList';
import * as footerTypes from '../../types/FooterTypes.type';
import { FooterHeader } from './FooterLI';

export default function FooterLinkSection(
  footerProps: footerTypes.FooterProps,
) {
  const { footerItems } = footerProps;
  const listItems = filterEmpty(footerItems).map(
    (item) => item.children && (
      <li
        key={`${item.children?.at(0)?.url} + ${item.children?.at(0)?.text}`}
        tw=" basis-1/2 px-0.5 sm:basis-1/3 lg:basis-56"
      >
        <FooterHeader>{item.text}</FooterHeader>
        <FooterList items={item.children ?? []} />
        {' '}
      </li>
    ),
  );
  return (
    <div tw="mx-auto py-5 px-4 leading-relaxed md:px-5 lg:max-w-7xl">
      <ul tw="flex flex-wrap justify-evenly text-[.75rem]">{listItems}</ul>
      {' '}
    </div>
  );
}
